export default __webpack_public_path__ + "static/media/core_values.81dd9de9.png";